type DevtoolsTrackEvent = {
  type: 'trackEvent';
  action: string;
  label?: string;
  categoryOverride?: string;
  contextualData?: Record<string, unknown>;
};

type DevtoolsJourneyEvent = {
  type: 'trackJourneyEvent';
  categoryName: string;
  eventName: string;
  eventData: Record<string, unknown>;
  contextualData?: Record<string, unknown>;
};

export type DevtoolsEvent = DevtoolsTrackEvent | DevtoolsJourneyEvent;

type DevtoolsEventSubscriber = (event: DevtoolsEvent) => void;

const subscribers = new Set<DevtoolsEventSubscriber>();

const MAX_BUFFERED_EVENTS = 500;
const eventBuffer: DevtoolsEvent[] = [];

export function subscribeToDevtoolsEvents(callback: DevtoolsEventSubscriber): () => void {
  // Replay buffered events to new subscriber
  eventBuffer.forEach((event) => callback(event));

  subscribers.add(callback);
  return () => subscribers.delete(callback);
}

export function emitDevtoolsEvent(event: DevtoolsEvent): void {
  // Buffer event for future subscribers
  eventBuffer.push(event);
  if (eventBuffer.length > MAX_BUFFERED_EVENTS) {
    eventBuffer.shift();
  }

  subscribers.forEach((callback) => callback(event));
}
